function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconActionTickError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8 8.2a.667.667 0 0 1 .07.86l-.07.083L12.943 12l2.857 2.862a.667.667 0 0 1 .07.86l-.07.083a.667.667 0 0 1-.86.07l-.083-.07L12 12.943 9.138 15.8a.667.667 0 0 1-.86.07L8.2 15.8a.667.667 0 0 1-.07-.86l.07-.083L11.057 12 8.2 9.138a.667.667 0 0 1-.07-.86L8.2 8.2a.667.667 0 0 1 .86-.07l.083.07L12 11.057 14.862 8.2a.667.667 0 0 1 .938 0z",
    transform: "translate(-8 -8)",
    style: {
      fill: "#be4949"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionTickError);
export default __webpack_public_path__ + "static/media/icon-action-tick-error.f8b2b81f.svg";
export { ForwardRef as ReactComponent };